export default theme => ({

  title: {
    paddingTop: '30%'
  }

});




// WEBPACK FOOTER //
// ./src/styles/components/NoData.js